<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'
import ArrowIcon from '@/components/shared/ArrowIcon.vue'

const { t } = useI18n()

const audiences = [
  { key: 'organizers', to: '/for-organizers', button: 'bg-emerald-500 hover:bg-emerald-400', dot: 'text-emerald-500' },
  { key: 'participants', to: '/for-participants', button: 'bg-sky-600 hover:bg-sky-500', dot: 'text-sky-500' },
] as const

const bullets = ['b1', 'b2', 'b3'] as const
</script>

<template>
  <section class="bg-slate-50 py-24" aria-labelledby="about-help-title">
    <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-12">
        <p class="text-emerald-600 font-semibold text-sm uppercase tracking-widest">{{ t('about.how_we_help.eyebrow') }}</p>
        <h2 id="about-help-title" class="text-3xl md:text-4xl font-bold text-slate-900 mt-3">
          {{ t('about.how_we_help.title') }}
        </h2>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div
          v-for="audience in audiences"
          :key="audience.key"
          class="bg-white rounded-2xl border border-slate-100 p-8 flex flex-col"
        >
          <h3 class="text-xl font-bold text-slate-900">{{ t(`about.how_we_help.${audience.key}.title`) }}</h3>
          <p class="mt-2 text-slate-600 leading-relaxed">{{ t(`about.how_we_help.${audience.key}.body`) }}</p>
          <ul class="mt-5 space-y-2 flex-1">
            <li v-for="b in bullets" :key="b" class="flex items-start gap-2 text-sm text-slate-600">
              <svg class="w-5 h-5 shrink-0" :class="audience.dot" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M16.704 5.296a1 1 0 010 1.408l-7.5 7.5a1 1 0 01-1.408 0l-3.5-3.5a1 1 0 011.408-1.408L8.5 12.092l6.796-6.796a1 1 0 011.408 0z" clip-rule="evenodd" />
              </svg>
              {{ t(`about.how_we_help.${audience.key}.${b}`) }}
            </li>
          </ul>
          <RouterLink
            :to="audience.to"
            class="mt-6 inline-flex items-center justify-center gap-2 text-white font-semibold rounded-lg px-6 py-3 text-sm transition-colors"
            :class="audience.button"
          >
            {{ t(`about.how_we_help.${audience.key}.cta`) }}
            <ArrowIcon direction="right" class="w-4 h-4" />
          </RouterLink>
        </div>
      </div>
    </div>
  </section>
</template>
